<template>
  <div>
    <span class="caption font-weight-bold">
      {{ label }}
      :
    </span>
    <div class="caption" v-if="loading">
      Chargement..
    </div>
    <v-tooltip bottom color="background" v-else-if="value">
      <template v-slot:activator="{ on }">
        <v-chip
          v-on="on"
          small
          v-bind="$attrs"
          @click="$emit('click', $event)"
          class="caption text-end"
        >
          {{ value }}
        </v-chip>
      </template>
      <slot />
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'custom-data-chips',
  props: {
    label: { type: String, required: true },
    value: { type: String, required: false },
    loading: { type: Boolean, required: false },
  },
};
</script>
